import axios from 'axios'
import {UposlenikModel, Option} from '../models/UposlenikModel'
import {getAuth} from '../modules/auth'
import {Drzava} from '../models/Drzava'

const API_URL = process.env.REACT_APP_API_URL
const API = `${API_URL}/drzava`
const SELECT = `${API_URL}/drzavaDropdown`
const PANELI_DRZAVE_DROPDOWN = `${API_URL}/getPaneliDrzaveDropdown`
const auth: UposlenikModel = getAuth()!
const headers = {Accept: 'application/json', Authorization: `Bearer ${auth?.access_token ?? ''}`}

export async function getDrzavaDropdown() {
  return await axios.get<Array<Option>>(SELECT, {headers: headers})
}

export async function getPaneliDrzaveDropdown() {
  return await axios.get<Array<Option>>(PANELI_DRZAVE_DROPDOWN, {headers: headers})
}

export async function getDrzava(pageNo: number, perPage: number) {
  const params = {per_page: perPage, page: pageNo}
  return await axios.get<Array<Drzava>>(API, {headers: headers, params: params})
}

export async function saveDrzava(Data: any) {
  return await axios.post(API, Data, {headers: headers})
}

export async function fetchDrzavaData(bojaId: number): Promise<Partial<Drzava>> {
  try {
    const response = await axios.get(`${API}/${bojaId}`, {headers: headers})
    if (response.data && response.data.error === 0) {
      return response.data.data
    } else {
      // Handle any other type of response structure or errors returned from the server here
      throw new Error(response.data.message || 'Failed to fetch Boja data.')
    }
  } catch (error) {
    console.error('Error fetching Boja data:', error)
    throw error // Re-throw the error so it can be handled by the caller if necessary
  }
}

export async function updateDrzava(bojaId: number, BojaData: Partial<Drzava>): Promise<any> {
  try {
    const response = await axios.put(`${API}/${bojaId}`, BojaData, {headers: headers})

    if (response.data && response.data.error === 0) {
      return response.data
    } else {
      // Handle any other type of response structure or errors returned from the server here
      throw new Error(response.data.message || 'Failed to update Boja data.')
    }
  } catch (error) {
    console.error('Error updating Boja data:', error)
    throw error // Re-throw the error so it can be handled by the caller if necessary
  }
}

export async function deleteBoja(bojaId: number) {
  try {
    const response = await axios.delete(`${API}/${bojaId}`, {headers: headers})
    if (response.data && response.data.error === 0) {
      return response
    } else {
      // Handle any other type of response structure or errors returned from the server here
      throw new Error(response.data.message || 'Failed to delete Boja.')
    }
  } catch (error) {
    console.error('Error deleting Boja data:', error)
    throw error // Re-throw the error so it can be handled by the caller if necessary
  }
}
